import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Mindset() {
  return <section className="py-24 bg-white relative" data-id="element-175">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center" data-id="element-176">
        <FadeIn data-id="element-177">
          <Quote className="w-16 h-16 text-brand-200 mx-auto mb-8" data-id="element-178" />
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-stone-900 mb-8 leading-tight" data-id="element-179">
            "El problema nunca fue tu fuerza de voluntad.
            <br data-id="element-180" />
            <span className="text-brand-600" data-id="element-181">El problema fue el sistema.</span>"
          </h2>
          <p className="text-xl text-stone-600 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-182">
            La mayoría de las personas no fracasa porque sea vaga. Fracasa
            porque intenta seguir sistemas imposibles. Tu objetivo durante los
            próximos 30 días no es ser perfecta. Tu objetivo es ser consistente.
          </p>

          <div className="bg-stone-50 border border-stone-200 rounded-3xl p-8 md:p-10 max-w-3xl mx-auto shadow-sm" data-id="element-183">
            <h3 className="text-sm font-bold text-stone-400 uppercase tracking-widest mb-4" data-id="element-184">
              Tu compromiso
            </h3>
            <p className="text-2xl md:text-3xl font-heading font-medium text-stone-800 italic" data-id="element-185">
              "Durante los próximos 30 días voy a enfocarme en progresar, no en
              ser perfecta."
            </p>
          </div>

          <div className="mt-12" data-id="element-186">
            <CtaButton label="Empezar mi transformación" data-id="element-187" />
          </div>
        </FadeIn>
      </div>
    </section>;
}